module.exports = __webpack_public_path__ + "assets/img/news-technology.8027f356.png";